import { useNavigate } from 'react-router-dom';
import { Box, Flex } from '@chakra-ui/react';

import { TextBold, TextMedium } from 'UiKit/typography';
import { ArrowLeftIcon } from 'Asset/icon';

import useCloseModalRestriction from 'View/schedule-generate/hooks/useCloseModalRestriction';

import styles from './styles.module.css';

const Head = () => {
  const navigate = useNavigate();
  const onCloseRestriction = useCloseModalRestriction();

  const handleBack = () => {
    onCloseRestriction(() => navigate('/schedule'));
  };

  return (
    <Box className={styles['head__container']}>
      <Flex justifyContent={'start'} height={'42px'}>
        <ArrowLeftIcon
          size="22px"
          className={styles['head__icon--arrow-left']}
          onClick={handleBack}
          color="var(--color-primary70)"
          data-testid="back-button-change-host-schedule"
        />
      </Flex>
      <TextBold className={styles['head__text--title']}>Ganti Host</TextBold>
      <TextMedium className={styles['form__text--subtitle']}>Berikut jadwal yang belum memiliki host. Silakan tetapkan host pengganti.</TextMedium>
    </Box>
  );
};

export default Head;
